import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface ChargePointListCustomerHeaderProps
  extends HeaderContext<
    GatewayChargePointModel,
    GatewayChargePointModel['customer']
  > {}

export const ChargePointListCustomerHeader =
  (): // props: ChargePointListCustomerHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER //////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-gateway-charge-point.customer');
  };
